import { useEffect, useRef } from 'react';

function useOnElementResize(element, handler) {
  const previousHeight = useRef();
  const previousWidth = useRef();

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        element?.offsetHeight !== previousHeight.current ||
        element?.offsetWidth !== previousWidth.current
      ) {
        handler?.();
      }

      previousHeight.current = element?.offsetHeight;
      previousWidth.current = element?.offsetWidth;
    }, 20);

    return () => clearInterval(interval);
  }, [element, handler]);
}

export default useOnElementResize;
